import PageHeader from 'components/global/PageHeader';

const CSLoginTitle = () => {
  return <PageHeader title="Log In to ECHO Knowledge" />;
};

export default CSLoginTitle;
